export { default } from "./ScoreEditor";
